<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'LABEL.additionalQuestions' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="wrapper">

  <form [formGroup]="form" id="customForm" (submit)="submit()">
    @for (field of customForm; track field) {
      <div class="field">
        <ion-item>
          @switch (field.type) {
            @case ('INTEGER') {
              <ion-input  [attr.aria-describedby]="'field-' + field.id"    [label]="field.userPrompt" labelPlacement="stacked" [formControlName]="field.id.toString()" type="number" inputmode="numeric"   placeholder="0" />
            }
            @case ('FLOAT') {
              <ion-input  [attr.aria-describedby]="'field-' + field.id"      [label]="field.userPrompt" labelPlacement="stacked" [formControlName]="field.id.toString()" type="number" inputmode="decimal" step="any" placeholder="0.0" />
            }
            @case ('BOOLEAN') {
              <ion-toggle [attr.aria-describedby]="'field-' + field.id"    labelPlacement="start" justify="space-between" [formControlName]="field.id.toString()">{{ field.userPrompt }}</ion-toggle>
            }
            @default {
              <ion-input  [attr.aria-describedby]="'field-' + field.id" type="text" [label]="field.userPrompt" labelPlacement="stacked" [formControlName]="field.id.toString()" placeholder="..." />
            }
          }
        </ion-item>
        <form-error
          [name]="field.id.toString()"
          [id]="'field-' + field.id"
          [customMessage]="{ decimal: wholeNumberError }"
          />
      </div>
    }
  </form>
</ion-content>

<ion-footer>
  <ion-row>

    <ion-col>
      <ion-button
        type="button"
        color="primary"
        fill="outline"
        expand="block"
        (click)="cancel()"
        >
        {{  'ACTION.cancel' | translate }}
        <ion-icon name="ban-outline" slot="end" />
      </ion-button>
    </ion-col>

    <ion-col>
      <ion-button
        type="submit"
        form="customForm"
        color="primary"
        expand="block"
        [disabled]="form.invalid || submitting"
        data-testid="custom-fields-submit"
        >
        {{  'ACTION.submit' | translate }}
        <ion-icon name="checkmark" slot="end" />
      </ion-button>
    </ion-col>
  </ion-row>
</ion-footer>
